import settings from '@/settings'
import Logger from '@/logger'
import { createSessionWidget } from '@/utils/sessionWidget'
import { getAuthenticationActionUrl } from '@/helpers'
import { ERRORS } from '@/constants'

export const REQUEST = 'REQUEST'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'
export const LOGOUT = 'LOGOUT'

const defaultState = {
  token: '',
  user: null,
  error: null,
  isAuthorizing: false,
  requested: false
}

export default {
  namespaced: true,
  state () {
    return defaultState
  },
  actions: {
    async authenticate ({ commit, dispatch }, withoutLoginRedirect = false) {
      commit(REQUEST)

      try {
        const sessionWidget = await createSessionWidget(settings.get('SSW_CLIENT_ID'))
        const [{ access_token: token }, account] = await Promise.all([
          sessionWidget.requestToken(),
          sessionWidget.getAccountInfo()
        ])

        commit(SUCCESS, { token, account })
      } catch (error) {
        commit(FAILURE, error)

        if (error.error === ERRORS.ACCESS_DENIED.code) {
          if (!withoutLoginRedirect) {
            dispatch('loginRedirect')
          }
        } else {
          Logger.error(error)
        }
      }
    },
    logout ({ commit }) {
      commit(LOGOUT)
    },
    /**
     * Redirect to login page
     * @param {string} next
     */
    loginRedirect ({ commit }) {
      const redirectUrl = getAuthenticationActionUrl('signin')
      location.assign(redirectUrl)
    }
  },
  getters: {
    isAuthorized: ({ user }) => user !== null,
    userID: ({ user }, getters) => getters.isAuthorized ? user.id.toString() : null
  },
  mutations: {
    [REQUEST] (state) {
      state.isAuthorizing = true
    },
    [SUCCESS] (state, { token, account }) {
      Object.assign(state, {
        token,
        user: {
          id: account.id,
          name: account.nickname
        },
        isAuthorizing: false,
        requested: true
      })
    },
    [FAILURE] (state, error) {
      Object.assign(state, defaultState, {
        error,
        requested: true
      })
    },
    [LOGOUT] (state) {
      Object.assign(state, defaultState, {
        requested: true
      })
    }
  }
}
